import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=1a5e2440&scoped=true&"
import script from "./Trips.vue?vue&type=script&lang=ts&"
export * from "./Trips.vue?vue&type=script&lang=ts&"
import style0 from "./Trips.vue?vue&type=style&index=0&id=1a5e2440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e2440",
  null
  
)

export default component.exports